import { useState, useRef, useEffect } from "react";

interface UseStreamTrackingProps {
  isPlaying: boolean;
  trackId: string;
  canTrack: boolean;
}

export function useStreamTracking({
  isPlaying,
  trackId,
  canTrack,
}: UseStreamTrackingProps) {
  const [streamDuration, setStreamDuration] = useState(0);
  const playTimer = useRef<NodeJS.Timeout | null>(null);

  // Reset state when track changes
  useEffect(() => {
    console.log("🔄 Resetting stream tracking state for track:", trackId);
    setStreamDuration(0);

    if (playTimer.current) {
      clearInterval(playTimer.current);
      playTimer.current = null;
    }
  }, [trackId]);

  // Start/stop tracking when playback status changes
  useEffect(() => {
    if (isPlaying && canTrack) {
      console.log("⏱️ Starting stream tracking timer for track:", trackId);
      playTimer.current = setInterval(() => {
        setStreamDuration((prev) => {
          const newDuration = prev + 1;
          console.log(
            `⏰ Stream duration: ${newDuration}s for track:`,
            trackId,
          );
          return newDuration;
        });
      }, 1000);
    } else if (!isPlaying && playTimer.current) {
      console.log("⏹️ Stopping stream tracking timer for track:", trackId);
      clearInterval(playTimer.current);
      playTimer.current = null;
    }

    return () => {
      if (playTimer.current) {
        clearInterval(playTimer.current);
        playTimer.current = null;
      }
    };
  }, [isPlaying, canTrack, trackId]);

  return { streamDuration };
}
